import './Product.css';

function Product() {
  return (
    <>
      <p>Product Component</p>
    </>
  );
}

export default Product;
